import { createRouter, createWebHistory } from "vue-router";
import WelcomePage from "../views/welcomepage.vue";
import Userspage from "../views/UsersPage.vue";
import DashboardView from "../views/DashboardView.vue";
import AppLayout from "../components/AppLayout.vue";
import CategoriesView from "@/views/CategoriesView.vue";
import PhraseLibraryView from "@/views/PhraseLibraryView.vue";
import store from "../store";
import { getMemoryAuthToken } from "../localServerAuth";

const routes = [
  { path: "/login", name: "WelcomePage", component: WelcomePage },
  {
    path: "/",
    component: AppLayout,
    children: [
      { path: "dashboard", name: "Dashboard", component: DashboardView, meta: { requireAuth: true } },
      { path: "users", name: "Users", component: Userspage, meta: { requireAuth: true } },
      { path: "categories", name: "Categories", component: CategoriesView, meta: { requireAuth: true } },
      { path: "phraselibrary", name: "PhraseLibrary", component: PhraseLibraryView, meta: { requireAuth: true } },
    ],
  },

  { 
    path: "/logout", 
    name: "Logout", 
    component: { template: '<div>Logging out...</div>' }, 
    beforeEnter: (to, from, next) => {  
      localStorage.removeItem("adminuserid");
      // localStorage.removeItem("token");  
      localStorage.removeItem("link");
      localStorage.removeItem("isSuperAdmin");
      next({ path: "/login" });
    } 
  },
];

const router = createRouter({
  // Must match vue.config publicPath (/admin/ on singlevm) — otherwise /admin/ matches no route (blank UI)
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path === "/") {
    const isSuperAdmin = localStorage.getItem("isSuperAdmin") === "true";
    if (isSuperAdmin) {
      next({ path: "/phraselibrary" });
    } else {
      next({ path: "/dashboard" });
    }
    return;
  }
  if (to.meta.requireAuth) {
    const adminId = localStorage.getItem("adminuserid");
    if (!adminId) {
      console.log("Not authenticated → redirect to login");
      next({ path: "/login" });
      return;
    }
    const isSuperAdmin = localStorage.getItem("isSuperAdmin") === "true";
    if (!isSuperAdmin && to.path === "/phraselibrary") {
      next({ path: "/dashboard" });
      return;
    }
    // HEL-2250: clinic JWT is memory-only — remint from Auth cookie on refresh.
    const link = localStorage.getItem("link");
    const hasToken = !!(store.state.token || getMemoryAuthToken());
    if (!hasToken && link) {
      store
        .dispatch("checkAuth", link)
        .then(async (auth) => {
          if (auth && auth.token) {
            store.commit("SET_TOKEN", auth.token);
            await store.dispatch("establishAuthSession", {
              linkId: link,
              deviceLabel: "Helen admin",
            });
            next();
            return;
          }
          next({ path: "/login" });
        })
        .catch(() => next({ path: "/login" }));
      return;
    }
    next();
  } else {
    next();
  }
});

export default router;
